import { Search } from '@mui/icons-material';
import { InputBase, SxProps, Theme, useTheme } from '@mui/material';
import { sxToObject } from '../../utils/global/helper';

interface Props {
  placeholder?: string;
  endAdornment?: React.ReactNode;
  sx?: SxProps<Theme>;
  value?: string;
  onChange?: (val: string) => void;
  autoFocus?: boolean;
  onClick?: () => void;
  mobileHideIcon?: boolean;
}

function SearchInput({
  endAdornment,
  placeholder,
  sx,
  value,
  onChange,
  autoFocus,
  onClick,
  mobileHideIcon,
}: Props) {
  const theme = useTheme();
  return (
    <InputBase
      startAdornment={
        <Search
          sx={{
            width: '24px',
            color: 'text.secondary',
            mr: 1,
            display: {
              xs: mobileHideIcon ? 'none' : 'block',
              md: 'block',
            },
          }}
        />
      }
      endAdornment={endAdornment}
      placeholder={placeholder}
      autoFocus={autoFocus}
      fullWidth
      value={value || ''}
      onChange={e => {
        const val = e.target.value;
        onChange?.(val);
      }}
      sx={{
        bgcolor: 'background.paper',
        px: 1.5,
        py: {
          xs: 2,
          md: 1.5,
        },
        fontSize: theme.typography.body1.fontSize,
        ...sxToObject(sx, theme),
      }}
      onClick={onClick}
    />
  );
}

export default SearchInput;
